import { createAPIActions } from 'barnyard/utils';
import { APP_URL } from '../constants';

// Various URLs we care about
export const NAME = 'merchants/signup';
export const BASE_URL = `/${APP_URL}/${NAME}`;
export const USER_FORM_URL = `${BASE_URL}/user`;
export const VENDOR_FORM_URL = `${BASE_URL}/vendor`;

export const FINISHED_URL = '/vendor/selling';

// Different form identifies
export const SIGNUP_FORM = 'MerchantUserInformation';
export const VENDOR_MERCHANT_UPDATE_FORM = 'VendorMerchantUpdateForm';

// Profile Actions
export const MERCHANT_PROFILE_CREATE = createAPIActions('PROFILE_CREATE');
export const MERCHANT_PROFILE_FETCH = createAPIActions('PROFILE_FETCH');

// Vendor Actions
export const VENDOR_UPDATE = createAPIActions('VENDOR_UPDATE');
export const VENDOR_FETCH = createAPIActions('VENDOR_FETCH');

// LocalStorage form locations
export const LOCAL_STORAGE_VENDOR_FORM = '_saved_vendormerchant_form';
export const LOCAL_STORAGE_PROFILE_FORM = '_saved_profile_form';
